import React, { useEffect } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"
import { PortableText } from "@portabletext/react"
import { getGatsbyImageData } from "gatsby-source-sanity"

const motionSection = {
  hidden: {
    opacity: 0,
    // y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.16, 1, 0.3, 1],
      // when: "beforeChildren",
    },
  },
}
const motionItems = {
  hidden: {
    opacity: 0,
    y: 20,
    // rotate: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const motionImage = {
  hidden: {
    scale: 1.1,
    opacity: 0,
    // rotate: 20,
  },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 1,
      // ease: [0.87, 0, 0.13, 1],
    },
  },
}

const underline = {
  hidden: {
    // opacity: 0,
    width: 0,
  },
  visible: {
    opacity: 1,
    // right: 0,
    width: "100%",
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const title = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}
const desc = {
  hidden: {
    opacity: 0,
    y: 20,
  },
  visible: {
    opacity: 1,
    // right: 0,
    y: 0,
    transition: {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
    },
  },
}

const headingText = ({ block }) => {
  const { heading, description, _rawPortableText } = block
  const controls = useAnimation()
  const [ref, inView] = useInView()

  useEffect(() => {
    if (inView) {
      controls.start("visible")
    }
  }, [controls, inView])

  return (
    <motion.section
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={motionSection}
      className="section multicolumn"
    >
      {/* <div className="grid grid-cols-3"> */}

      <div className="module-image-text-carousel__content flex flex-col justify-center mb-8 items-center text-center container max-w-screen-md">
        <h2 className="w-fit h2 mb-6 relative">
          <motion.div variants={title}>{heading}</motion.div>
          {/* <motion.div
            variants={underline}
            className="section-heading__underline bg-orange-400 h-2 w-full absolute -bottom-4 left-0 "
          /> */}
        </h2>
        <motion.p variants={desc}>{description}</motion.p>

        <motion.div variants={desc} className="prose text-black ">
        <PortableText
          value={_rawPortableText}
          components={{
            types: {
              image: ({ value }) => (
                <GatsbyImage
                  alt="Fetch Park"
                  image={getGatsbyImageData(
                    value.asset._ref,
                    { maxWidth: 1024 },
                    sanityConfig
                  )}
                />
              ),
            },
          }}
          onMissingComponent={false}
        />
      </motion.div>
      </div>

    </motion.section>
  )
}

export default headingText
